module.exports = __webpack_public_path__ + "img/id_demo_e.2e1f09a9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/id_demo_e.jpg
// module id = rVI2
// module chunks = 1